import { createFileRoute } from '@tanstack/react-router';

import { RemedySettingsPage } from '@/features/code-remedy/RemedySettingsPage';

export const Route = createFileRoute('/_protected/t/$tenantId/code-modernization/$remedyId/settings')({
  component: RemedySettingsRoute,
});

function RemedySettingsRoute() {
  const { remedyId } = Route.useParams();

  return <RemedySettingsPage remedyId={remedyId} />;
}
